import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IViewOrganizationStrings extends LocalizedStringsMethods {
    lsOrgTxt: string;
    lsLevelTxt: string;
    lsOrganizationsTxt: string;
    lsCustomersTxt: string;
    lsContactFirstNameTxt: string;    
    lsContactLastNameTxt: string;
    lsContactPhoneTxt: string;
    lsContactEmailTxt: string;    
    lsAddressTxt: string;
    lsOrgEmailTxt: string;
    lsWebsiteTxt: string;
    lsTestHistoryTxt: string;
    lsShareTextTxt: string;
    lsPrintTxt: string;
    lsDownloadTxt: string;
    lsExportTxt: string;
    lsOkTxt: string;
    lsTestExportSuccessTxt: string;
    lsTestSharedSuccessTxt: string;
    lsTestShareFailTxt: string;
    lsShareTxt: string;
    lsExportOrganizationTxt: string;
    lsUserListTxt: string;
    lsContactInfoTxt: string;
    lsActiveTxt: string;
    lsYesTxt: string;
    lsNoTxt: string;
    lsCityTxt: string;
    lsStateTxt: string;
    lsCountryTxt: string;
    lsZipPostalCodeTxt: string;
}

let strings: IViewOrganizationStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsOrgTxt: 'Organization',
        lsLevelTxt: 'Level',
        lsOrganizationsTxt: 'Organizations',
        lsCustomersTxt: 'Customers',
        lsEditTxt: 'Edit',
        lsContactFirstNameTxt: 'First Name',
        lsContactLastNameTxt: 'Last Name',
        lsContactPhoneTxt: 'Phone',
        lsContactEmailTxt: 'Email',    
        lsAddressTxt: 'Address',
        lsOrgEmailTxt: 'Email',
        lsWebsiteTxt: 'Website',
        lsTestHistoryTxt: 'Test History',
        lsShareTextTxt: 'Share Test',
        lsPrintTxt : 'Print',
        lsDownloadTxt: 'Download',
        lsExportTxt: 'Export Organization List',
        lsOkTxt: 'Ok',
        lsTestExportSuccessTxt: 'Tests exported successfully!',        
        lsTestSharedSuccessTxt: 'Tests shared successfully!',
        lsTestShareFailTxt: 'Tests could not be shared.Please try again!',
        lsShareTxt: 'Share',
        lsExportOrganizationTxt: 'Export Organization List',
        lsUserListTxt: 'User List',
        lsContactInfoTxt: 'Contact Info',
        lsActiveTxt: 'Active',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsCityTxt: 'City',
        lsStateTxt: 'State',
        lsCountryTxt: 'Country',
        lsZipPostalCodeTxt: 'Zip/Postal Code',
    },
    es: {       
        lsOrgTxt: 'Organización',
        lsLevelTxt: 'Nivel',
        lsOrganizationsTxt: 'Organizations',
        lsCustomersTxt: 'Clientes',
        lsEditTxt: 'Editar',
        lsContactFirstNameTxt: 'First Name',
        lsContactLastNameTxt: 'Last Name',
        lsContactPhoneTxt: 'Teléfono',
        lsContactEmailTxt: 'Correo electrónico',    
        lsAddressTxt: 'Address',
        lsOrgEmailTxt: 'Email',
        lsWebsiteTxt: 'Sitio web',
        lsTestHistoryTxt: 'Historial de prueba',
        lsShareTextTxt: 'Compartir prueba',
        lsPrintTxt : 'Impresión',
        lsDownloadTxt: 'Descargar',
        lsExportTxt: 'Exportar lista de Organizations',
        lsOkTxt: 'De acuerdo',
        lsTestExportSuccessTxt: 'Pruebas exportadas con éxito',        
        lsTestSharedSuccessTxt: '¡Pruebas compartidas exitosamente!',
        lsTestShareFailTxt: 'Las pruebas no se pudieron compartir. ¡Inténtalo de nuevo!',
        lsShareTxt: 'Share',
        lsExportOrganizationTxt: 'Export Organization List',
        lsUserListTxt: 'User List',
        lsContactInfoTxt: 'Contact Info',
        lsActiveTxt: 'Active',
        lsYesTxt: 'Yes',
        lsNoTxt: 'No',
        lsCityTxt: 'City',
        lsStateTxt: 'State',
        lsCountryTxt: 'Country',
        lsZipPostalCodeTxt: 'Zip/Postal Code',
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/organization/strings.organization.view.tsx